module.exports = __webpack_public_path__ + "static/img/villentretenmerth.b13735c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/villentretenmerth.png
// module id = 48qQ
// module chunks = 0